// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2kK7D","imageUploader":"EGiftCard_imageUploader__2QzV0"};